<div class="payment__info">
  <p>TOTAAL: {{data.order.order.totalPrice | currency: 'EUR' }}</p>
</div>

<ion-item>
  <ion-input [formControl]="received" type="number" placeholder="Vul hoeveelheid cash in"></ion-input>
</ion-item>

<div class="ion-margin-top">
  <div *ngIf="change && !received.errors">
    <p>Je moet de klant <b>{{change | currency: 'EUR'}} </b> teruggeven.</p>
  </div>

  <div *ngIf="received.errors?.['min'] && !received.errors?.['pattern']">
    Je moet minstens <b>{{received.errors?.['min'].min | currency: 'EUR'}}</b> gekregen hebben.
  </div>

  <div *ngIf="received.errors?.['pattern']">
    Geef een geldig bedrag in met maximaal 2 cijfers na de komma.
  </div>
</div>